import { filterObj } from 'ui-lib';
import fetchApi from '../fetch-api';
import * as t from 'io-ts';

export const CompanySearchIO = t.type({
  companyID: t.string,
  name: t.string,
  licence_no: t.string,
});

export type CompanySearch = t.TypeOf<typeof CompanySearchIO>;

const companySearchWithSicQuery = ({
  searchKey,
  sicCodes,
}: {
  searchKey?: string;
  sicCodes?: string[];
}) => {
  let query = "";

  if (searchKey) {
    query += `searchQuery=${encodeURIComponent(searchKey)}`;
  }

  if (sicCodes && sicCodes.length > 0) {
    // Encode individual codes but keep commas
    const sicParam = `sicCode=${sicCodes.map(code => encodeURIComponent(code)).join(",")}`;
    query += query ? `&${sicParam}` : sicParam;
  }

  return {
    queryKey: [
      'search-company-with-sic',
      filterObj({ searchKey, sicCodes }, (_, value) => !!value && value.length > 0),
    ],
    queryFn: () =>
      fetchApi({
        service: 'admin-service',
        pathname: `/search-company-with-sic?${query}`,
        headers: { method: 'GET' },
        codec: t.array(CompanySearchIO),
      }),
    keepPreviousData: true,
  };
};

export default companySearchWithSicQuery;
